import React from "react";
import FuseAnimate from "../fuse-animate/fuse-animate";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {Card} from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import clsx from 'clsx';
import ausPhone from "../../utils/aus-phone";
import {ArrowRightAlt, Schedule, Chat, FormatListNumbered, Voicemail, Block} from "@material-ui/icons";
import resolveAction from "../../utils/resolve-action";
import callCredits from "../../utils/call-credits";
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    header: {
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    numbersRow: {
        marginTop: theme.spacing(2),
        // marginBottom: theme.spacing(2),
    },
    accordionSummary: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        borderRadius: 4,
    },
    accordionDetails: {
        backgroundColor: '#e8eaf6',  // Indigo 50  //theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        paddingTop: 16,
    },
    summary: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        minHeight: 48,
        borderRadius: 4,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    },
    icon: {
        color: theme.palette.primary.contrastText,
    },
    number: {
        fontSize: 18,
        fontWeight: 700,
        '&.inActive': {
            textDecoration: 'line-through',
        },
    },
    forwarding: {
        flexWrap: 'nowrap',
        marginTop: 0,
        marginBottom: 2,
        [theme.breakpoints.down('xs')]: {
            // maxWidth: 220,
        },
    },
    sideManageButton: {
        color: 'white',
        borderColor: 'white',
        minWidth: 150,
        '&.Mui-disabled': {
            color: 'grey !important',
            borderColor: 'grey !important',
        }
    },
    linkButton: {
        marginTop: 4,
    },
    rechargeButton: {
        minWidth: 150,
        marginRight: 8,
        [theme.breakpoints.down('sm')]: {
            minWidth: 90,
            marginRight: 0,
        },
    }
}));


const ServicesCard = ({ account, animation, delay }) => {
    const classes = useStyles();

    // Only show active services
    let services = [];
    if (account.services) {
        services = account.services.filter((service) => {
            return service.active;
        })
    }

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="services-card" className={classes.root}>

                <Typography variant="h6" color="secondary">My Numbers</Typography>

                <div className={classes.numbersRow}>

                    { services.length === 0 ?
                        <Typography variant="body2">You have no active numbers.</Typography>
                        : null
                    }

                    <Hidden mdUp>
                    { services.map((service, index) => (
                        <div key={service.id} className="mb-4">
                            <Accordion>
                                <AccordionSummary
                                    className={classes.accordionSummary}
                                    style={{height: (service.meta.zone !== '' ? 140 : 110)}}
                                    expandIcon={<ExpandMoreIcon fontSize="large" className={classes.icon}/>}
                                >
                                    <Grid container direction="column" >
                                        <div>{service.name}</div>
                                        <div className={clsx(classes.number, {
                                            'inActive': service.active === 0})
                                        }>
                                            {ausPhone(service.number)}
                                        </div>
                                        { service.meta.zone !=='' ? <div className="mb-1">{service.meta.zone}</div>:null}
                                        <Grid item container alignItems="center" className={classes.forwarding}>
                                            <ServiceForwarding account={account} service={service}/>
                                        </Grid>
                                        <Grid item container alignItems="center" className={classes.forwarding}>
                                            <Credit service={service}/>
                                        </Grid>
                                    </Grid>

                                </AccordionSummary>

                                <AccordionDetails className={classes.accordionDetails}>
                                    <Grid container alignItems="center" justify="space-around">
                                        <Button variant="outlined"
                                                color="primary"
                                                size="large"
                                                className="w-full"
                                                component={Link}
                                                to={"/service/"+ service.id}
                                                disabled={account.status < 1}
                                        >Manage Number</Button>
                                    </Grid>
                                </AccordionDetails>

                            </Accordion>
                            <LowCreditWarning service={service} />
                        </div>
                    ))}
                    </Hidden>

                    <Hidden smDown>

                        { services.map((service, index) => (
                            <div key={service.id} className="mb-4">
                                <div className={classes.summary}>
                                    <Grid container
                                          direction="row"
                                          alignItems="center"
                                          justify="space-between"
                                          style={{height: (service.meta.zone !== '' ? 120 : 90)}}
                                    >
                                        <Grid item>
                                            <Grid container direction="column">
                                                <Grid item>{service.name}</Grid>
                                                <Grid item className={clsx(classes.number, {
                                                    'inActive': service.active === 0}
                                                    )}
                                                >
                                                    {ausPhone(service.number)}
                                                </Grid>
                                                { service.meta.zone !== '' ? <Grid item>{service.meta.zone}</Grid>:null}
                                                <Grid item container alignItems="center" className={classes.forwarding}>
                                                    <ServiceForwarding account={account} service={service}/>
                                                </Grid>
                                                <Grid item container alignItems="center" className={classes.forwarding}>
                                                    <Credit service={service}/>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Button variant="outlined"
                                                    size="large"
                                                    className={classes.sideManageButton}
                                                    component={Link}
                                                    to={"/service/" + service.id}
                                                    disabled={account.status < 1}
                                            >Manage</Button>
                                        </Grid>
                                    </Grid>
                                </div>
                                <LowCreditWarning service={service} />
                            </div>
                        ))}
                    </Hidden>


                </div>
                <Button variant="outlined"
                        color="primary"
                        size="large"
                        component={Link} to="/add-service"
                        className={classes.linkButton}
                        disabled={account.status < 1}
                >Add a Number</Button>
            </Card>
        </FuseAnimate>

    )
}


const ServiceForwarding = ({account, service}) => {

    // Choose which icon we'll use
    let icon;
    let type = service.action ? service.action.type : '';
    if (type === 'dial') {
        icon = null // <CallIcon fontSize="small"/>
    } else if (type === 'schedule') {
        icon = <Schedule fontSize="small"/>
    } else if (type === 'say' || type === 'play') {
        icon = <Chat/>
    } else if (type === 'voicemail') {
        icon = <Voicemail fontSize="small"/>
    } else if (type === 'ivr') {
        icon = <FormatListNumbered fontSize="small"/>
    } else if (type === 'reject') {
        icon = <Block fontSize="small"/>
    }

    // Resolve the number we're actually forwarding to
    const text = resolveAction(account, service).text;

    return (
        <React.Fragment>
            {icon} <ArrowRightAlt/> <Typography variant="body2">{text}</Typography>
        </React.Fragment>
    )
}

const Credit = ({service}) => {
    const {minutes, daysLeft} = callCredits(service);

    if (minutes > 0) {
        return (
            <>
                <TimerOutlinedIcon fontSize="small" className="mr-1"/>
                <div style={{marginTop: 1}} >{minutes} min ({daysLeft} {daysLeft === 1 ? 'day':'days'}) left</div>
            </>
        )
    } else {
        return (
            <>
                <ReportProblemOutlinedIcon fontSize="small"  className="mr-1"/>
                <div style={{marginTop: 1}} >No minutes left</div>
            </>
        )
    }
}

const LowCreditWarning = ({service}) => {
    const classes = useStyles();

    const {minutes, daysLeft} = callCredits(service);

    if (minutes <= 0) {
        return (
            <div className="filter drop-shadow bg-white flex flex-row items-center p-2">
                <ReportProblemOutlinedIcon className="text-red-500"/>
                <div className="text-gray-600 mx-2 flex-grow">You have run out of call minutes for this number!</div>
                <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.rechargeButton}
                    component={Link} to={`/recharge/${service.id}`}
                >
                    RECHARGE
                </Button>
            </div>
        )
    }
    if (minutes < 25) {
        return (
            <div className="filter drop-shadow bg-white flex flex-row items-center p-2">
                <ErrorOutlineIcon className="text-yellow-500"/>
                <div className="text-gray-600 mx-2 flex-grow">Your call minutes are getting low.</div>
                <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.rechargeButton}
                    component={Link} to={`/recharge/${service.id}`}
                >
                    RECHARGE
                </Button>
            </div>
        )
    }
    if (daysLeft < 7) {
        return (
            <div className="filter drop-shadow bg-white flex flex-row items-center p-2">
                <ErrorOutlineIcon className="text-yellow-500"/>
                <div className="text-gray-600 mx-2 flex-grow">Your call minutes will expire soon. Recharge now to keep them.</div>
                <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.rechargeButton}
                    component={Link} to={`/recharge/${service.id}`}
                >
                    RECHARGE
                </Button>
            </div>
        )
    }
    return null
}

export default ServicesCard